import api from './api';

export const serviceService = {
  async getAll() {
    const response = await api.get('/services');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/services/${id}`);
    return response.data;
  },

  async create(serviceData) {
    const response = await api.post('/services', serviceData);
    return response.data;
  },

  async update(id, serviceData) {
    const response = await api.put(`/services/${id}`, serviceData);
    return response.data;
  },

  async delete(id) {
    await api.delete(`/services/${id}`);
  },

  async search(searchTerm) {
    const response = await api.get(`/services/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    return response.data;
  }
};